//src/pages/Contact.js
import React from "react";
import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ContactHero from "../components/contact/ContactHero";
import ContactForm from "../components/contact/ContactForm";
import ContactInfo from "../components/contact/ContactInfo";
import ContactQuickLinks from "../components/contact/ContactQuickLinks";
import { useAppData } from "../store/dataStore";
import {
  MdEmail,
  MdPhone,
  MdChat,
  MdVideoCall,
  MdDownload,
  MdForum,
} from "react-icons/md";
import { componentMessaging } from "../data/messaging";
import { Helmet } from 'react-helmet-async';

const MotionBox = motion(Box);

const ContactPage = () => {
  const { appData } = useAppData();
  const { discordUrl, whatsappLink } = appData;

  // Centralized content from messaging.js
  const contact = componentMessaging.contact;

  // Map messaging.js into expected component structure
  const contactPageData = React.useMemo(
    () => ({
      hero: {
        title: contact.title,
        subtitle: contact.subtitle,
      },

      form: {
        title: contact.form.title,
        responseTime: contact.form.responseTime,
        interestOptions: contact.form.interestOptions,
      },

      contactInfo: {
        title: "Alternative Contact Methods",
        methods: [
          {
            icon: MdEmail,
            title: "Email",
            value: "support@ojasamirai.com",
            href: "mailto:support@ojasamirai.com",
            event: "email_click",
          },
          {
            icon: MdPhone,
            title: "Phone",
            value: "+91-9900309000",
            href: "tel:+91-9900309000",
            event: "phone_click",
          },
          {
            icon: MdChat,
            title: "WhatsApp",
            value: "Quick Chat",
            href: whatsappLink || "https://wa.me/919900309000",
            event: "whatsapp_click",
          },
        ],
      },

      quickLinks: {
        title: contact.quickLinks.title,
        links: contact.quickLinks.links.map((link) => {
          const iconMap = {
            Webinar: MdVideoCall,
            "View Curriculum": MdDownload,
            "Join Discord": MdForum,
          };
          return {
            ...link,
            icon: iconMap[link.title] || MdForum,
          };
        }),
      },
    }),
    [discordUrl, whatsappLink, contact]
  );

  // Optional: Analytics event
  React.useEffect(() => {
    console.log("GA Event: contact_page_view");
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us | Speak with an Ojasa Mirai Mentor</title>
        <meta name="description" content="Have questions about our GenAI programs? Schedule a 1-on-1 consultation or reach out via email, phone, or WhatsApp. We’ll respond within 24 hours." />
      </Helmet>

      <Box>
        <Navbar />

        <MotionBox
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          {/* Hero Section */}
          <ContactHero data={contactPageData.hero} />

          {/* Contact Form */}
          <Box py={{ base: 12, md: 20 }}>
            <ContactForm data={contactPageData.form} />
          </Box>

          {/* Contact Info */}
          <ContactInfo data={contactPageData.contactInfo} />

          {/* Quick Links Section */}
          <ContactQuickLinks data={contactPageData.quickLinks} />
        </MotionBox>

        <Footer />
      </Box>
    </>
  );
};

export default ContactPage;
